// extracted by mini-css-extract-plugin
export default {"title":"title-qDmLB","label":"label-sbS8E","inputs":"inputs-Mzpny","success":"success-hTuFy","error":"error-TKatt","option":"option-P3MyW"};